import { useRouter } from 'next/router'
import React, { FC, useCallback } from 'react'

import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'

import Desktop from '~/containers/Desktop'
import Mobile from '~/containers/Mobile'

import Deserializer from '~/services/Deserializer'
import REF from '~/services/REF'
import { getRole, isLogged, logoutUser } from '~/state/modules/user'
import { AppState } from '~/state/store'

import { ROLES } from '~/constants/roles'
import ROUTES from '~/constants/routes'

import HeaderDesktop from './Header.desktop'
import HeaderMobile from './Header.mobile'

export type HeaderProps = {
  incomingMessages?: boolean
  logged?: boolean
  logout?: () => void
}

const Header: FC<HeaderProps> = (props): JSX.Element => {
  const router = useRouter()
  const dispatch = useDispatch()
  const logged = useSelector(isLogged)
  const userId = useSelector((state: AppState) => state.user.user_id)
  const role = useSelector((state: AppState) => getRole(state))

  const logout = useCallback((): void => {
    dispatch(logoutUser())

    router.push(ROUTES.auth.signIn)
  }, [router, dispatch])

  const updateUser = async (): Promise<any> => {
    let userData

    if (role === ROLES.clinic) {
      userData = await REF.getClinicById(userId)
    }

    if (role === ROLES.image_center) {
      userData = await REF.getCenter(userId)
    }

    if (userData) {
      const data = await Deserializer.deserialize(userData)
      return data
    }

    return null
  }

  const { data } = useQuery('user', updateUser, {
    enabled: !!userId,
    // refetchInterval: 60000,
    refetchOnMount: true
  })

  return (
    <>
      <Desktop>
        <HeaderDesktop
          {...props}
          incomingMessages={data?.incoming_messages}
          logged={logged}
          logout={logout}
        />
      </Desktop>

      <Mobile>
        <HeaderMobile
          {...props}
          incomingMessages={data?.incoming_messages}
          logged={logged}
          logout={logout}
        />
      </Mobile>
    </>
  )
}

export default Header
